import { render } from "./CourseSidebar.vue?vue&type=template&id=31e77449"
import script from "./CourseSidebar.vue?vue&type=script&lang=js"
export * from "./CourseSidebar.vue?vue&type=script&lang=js"

import exportComponent from "/Users/gabrielalencar/Documents/custom/gestio-school-frontend-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__